import React from 'react';

import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import InquiryTypeCondition from 'components/InquiryTypeCondition';
import PortalPage from 'components/PortalPage';
import paths from 'constants/paths';
import ErrorBoundary from 'modules/ErrorBoundary';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import DataProvider from 'modules/InquiryDetails/FetchInquiryDetails';
import CustomerDashboard from 'pages/customerPortal/InquiryDetails/Dashboard';
import ObjectData from 'pages/customerPortal/InquiryDetails/Dashboard/ObjectData';
import DetailedInformation from 'pages/customerPortal/InquiryDetails/DetailedInformation';
import CustomerDocumentExchange from 'pages/customerPortal/InquiryDetails/DocumentExchange/CustomerDocumentExchange';
import NavigationBar from 'pages/customerPortal/InquiryDetails/NavigationBar';
import OnlineFactoringInquiryDetails from 'pages/customerPortal/InquiryDetails/OnlineFactoringInquiryDetails';
import CustomerPrivateRoute from 'routes/CustomerPrivateRoute';

import LeasePlanInquiryDetails from './LeasePlanInquiryDetails';
import CustomerInquiryEditGate from '../InquiryEdit/CustomerInquiryEditGate';

type Props = RouteComponentProps<{ id: string }>;

const InquiryDetails = ({
  match: {
    params: { id },
  },
}: Props) => {
  const redirectPath = paths.customer.inquiryDetails.dashboard.replace(':id', id);

  return (
    <ErrorBoundary>
      <DataProvider inquiryId={id}>
        <Switch>
          <CustomerPrivateRoute
            path={paths.customer.inquiryDetails.edit.root}
            component={CustomerInquiryEditGate}
          />
          <CustomerPrivateRoute
            path="*"
            render={() => (
              <PortalPage heading={<NavigationBar id={id} />}>
                <Switch>
                  <CustomerPrivateRoute
                    path={paths.customer.inquiryDetails.dashboard}
                    component={CustomerDashboard}
                  />
                  <CustomerPrivateRoute
                    path={paths.customer.inquiryDetails.details}
                    component={DetailedInformation}
                  />
                  <CustomerPrivateRoute
                    path={paths.customer.inquiryDetails.documentExchange}
                    component={CustomerDocumentExchange}
                  />
                  <CustomerPrivateRoute
                    path={paths.customer.inquiryDetails.objectData}
                    component={ObjectData}
                  />
                  <Route path="*" render={() => <Redirect to={redirectPath} />} />
                </Switch>
              </PortalPage>
            )}
          />
        </Switch>
      </DataProvider>
    </ErrorBoundary>
  );
};

const DisplayCondition = (props: Props) => {
  return (
    <InquiryTypeCondition
      portal
      cases={{
        [InquiryType.onlinefactoring]: <OnlineFactoringInquiryDetails />,
        [InquiryType.leaseplan]: <LeasePlanInquiryDetails />,
        [InquiryType.default]: <InquiryDetails {...props} />,
      }}
    />
  );
};

export default DisplayCondition;
